import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function NearMeIcon(props: IconProps) {
    return <Icon {...props} iconKey={"near_me"}/>
}
